import React from 'react';

export default function BuildingIcon() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M6.4339 6.43343H6.43973M8.76742 2.93343V1.76676C8.76742 1.45735 8.64449 1.1606 8.42568 0.941806C8.20687 0.723014 7.9101 0.600098 7.60066 0.600098H5.26714C4.95769 0.600098 4.66092 0.723014 4.44211 0.941806C4.2233 1.1606 4.10038 1.45735 4.10038 1.76676V2.93343M12.2677 7.01676C10.5367 8.1595 8.50813 8.76869 6.4339 8.76869C4.35966 8.76869 2.33111 8.1595 0.600098 7.01676M1.76686 2.93343H11.1009C11.7453 2.93343 12.2677 3.45577 12.2677 4.1001V9.93343C12.2677 10.5778 11.7453 11.1001 11.1009 11.1001H1.76686C1.12247 11.1001 0.600098 10.5778 0.600098 9.93343V4.1001C0.600098 3.45577 1.12247 2.93343 1.76686 2.93343Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
